import { render, staticRenderFns } from "./BarEcharts.vue?vue&type=template&id=fba5e0de&scoped=true&"
import script from "./BarEcharts.vue?vue&type=script&lang=js&"
export * from "./BarEcharts.vue?vue&type=script&lang=js&"
import style0 from "./BarEcharts.vue?vue&type=style&index=0&id=fba5e0de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba5e0de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
